import type { Visit } from '.';
import { SB, searchableComputedProperty } from '@play-co/replicant';

export const visitProperties = {
  /** Id of friend currently being visited, if any */
  visitingFriendId: searchableComputedProperty(
    SB.string(),
    ({ visit }: Visit.State) => visit.visitSession?.friendId ?? '',
  ),
};
